import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=27f0a8b4"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=27f0a8b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports